import { handleAction, combineActions } from 'redux-actions';

import { consentResponseAction, consentsLoadedAction } from '../actions/consent';
import { loginAction, logoutAction } from '../actions/authentication';
import { defaultErrorHandler, isError } from './errors';

const initialState = {};

const originIdAccessor = consent => consent.copyOf || consent.id;

export const consentsReducer = (state, action) => {
  if (action.type === logoutAction.toString() || action.type === loginAction.toString()) {
    // clean all data!
    return initialState;
  }

  if (isError(action)) {
    return state;
  }

  if (action.type === consentsLoadedAction.toString()
  || action.type === consentResponseAction.toString()) {
    if (!action.payload) {
      console.warn('Empty action!', action);
      return state;
    }
    const consents = action.payload.consents || action.payload;
    return consents.reduce((map, c) => {
      const id = originIdAccessor(c);
      const { server, organization, practitioner, requested, given, denied } = c;
      if (!map[id]) {
        map[id] = { server, organization, practitioner, instances: [] };
      } else if (server !== map[id].server
        || organization !== map[id].organization
        || practitioner !== map[id].practitioner) {
        console.warn('Non-matching consent instances!', map[id], c);
        return map;
      }
      map[id].instances.push({ requested, given, denied });
      return map;
    }, {});
  }
  return state;
};

export default handleAction(combineActions(
  consentResponseAction,
  consentsLoadedAction,
), {
  next: consentsReducer,
  throw: defaultErrorHandler,
}, initialState);
